import { useEffect, useRef } from 'react'

type ICallback = () => void

const useInterval = (callback: ICallback, delay = 0): void => {
  const savedCallbackRef = useRef<ICallback>(callback)
  const intervalIdRef = useRef<NodeJS.Timer>(undefined)

  useEffect((): void => {
    savedCallbackRef.current = callback
  }, [callback])

  useEffect(() => {
    intervalIdRef.current && clearInterval(intervalIdRef.current as NodeJS.Timeout)
    if (delay != null) {
      intervalIdRef.current = setInterval(savedCallbackRef.current, delay)
    }
    return () => intervalIdRef.current && clearInterval(intervalIdRef.current as NodeJS.Timeout)
  }, [delay])
}

export default useInterval
